import React, { useState, useEffect } from "react";

import "./search-result.styles.scss";

// icons
import MsWordIcon from '../../assets/icons/Icon - Word.svg';
import MsExcelIcon from '../../assets/icons/Icon - Excel.svg';
import MsPPTIcon from '../../assets/icons/Icon - PowerPoint.svg';
import TaskIcon from '../../assets/icons/Icon - Tasks.svg';
import ProjectIcon from '../../assets/icons/Icon - Projects.svg';


const SearchResult = ({input, length, type}) => {

  const [icon, setIcon] = useState('tasks');

  useEffect(() => {
    if (type === 'Docx') setIcon(MsWordIcon);
    else if (type === 'Excel') setIcon(MsExcelIcon);
    else if (type === 'PPT') setIcon(MsPPTIcon);
    else if (type === 'Project') setIcon(ProjectIcon);
    else if (type === 'Task') setIcon(TaskIcon);
  
  }, [])


  return (
    <tr className="search-result-container">
      <td>
        <div className="search-result-name-type-container">
          <span className='search-result-name'>'{input}'</span>
          <span className={"search-result-type search-result-text-light"}>
            in {type}
          </span>
        </div>
      </td>
      <td>
        <div className="search-result-icon-number-container">
          <span className="search-result-number search-result-text-light ">
            {length}{`${length === 1? ' result' : ' results'}`}
          </span>
          <img className={'search-result-icon'} alt="docx-icon" src={icon} />
        </div>
      </td>
    </tr>
  );
};

export default SearchResult;
